import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import PianoScale from './PianoScale';
import ScaleChords from './ScaleChords';
import useAnchoredPopup from '../../hooks/useAnchoredPopup';

import './PianoScalePopup.scss';

/**
 * Floating PianoScale popup using a portal — same approach as ChordPiano.
 * Renders directly into document.body to avoid any rc-tooltip wrapper issues.
 *
 * Below the keyboard it lists the key's diatonic chords; picking one lights that
 * chord's tones on the keyboard above.
 *
 * Props:
 *   currentKey  – the song key to display
 *   anchorRect  – DOMRect of the trigger element (null = hidden)
 *   onClose     – called when the user clicks/taps outside
 */
const PianoScalePopup = ({ currentKey, anchorRect, onClose }) => {
  const popupRef = useAnchoredPopup(anchorRect, onClose);
  const [activeChord, setActiveChord] = useState(null);

  // Start clean every time the popup opens, or when the song key changes under it
  useEffect(() => {
    setActiveChord(null);
  }, [anchorRect, currentKey]);

  if (!anchorRect) return null;

  return ReactDOM.createPortal(
    <div ref={popupRef} className="piano-scale-popup" style={{ visibility: 'hidden' }}>
      <PianoScale currentKey={currentKey} activeChord={activeChord} />
      <ScaleChords currentKey={currentKey} activeChord={activeChord} onSelect={setActiveChord} />
    </div>,
    document.body,
  );
};

export default PianoScalePopup;
